import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';
import { getRouteByActivityType } from 'src/app/board/activity/activity-shared/activity-shared-routes';
import { RouteActivityType } from 'src/app/board/activity/activity.constants';

export const activitySharedResourcesRoutes: MenuInterface[] = [
    {
        code: 'SharedRessourcesParameters',
        route: getRouteByActivityType('ActivityParameters', RouteActivityType.SharedResources)
    },
    {
        code: 'SharedRessourcesPermanenceParameters',
        route: getRouteByActivityType('PermanencesSettings', RouteActivityType.SharedResources)
    },
    {
        code: 'SharedRessourcesMediaCatalog',
        route: getRouteByActivityType('MediaCatalog', RouteActivityType.SharedResources)
    },
    {
        code: 'SharedRessourcesMediaFamily',
        route: getRouteByActivityType('MediaFamily', RouteActivityType.SharedResources)
    },
    {
        code: 'SharedRessourcesStockQuantities',
        route: getRouteByActivityType('StockQuantities', RouteActivityType.SharedResources)
    },
    {
        code: 'SharedRessourcesMovements',
        route: getRouteByActivityType('StockMovements', RouteActivityType.SharedResources)
    },
    {
        code: 'SharedRessourcesInvoicesList',
        route: getRouteByActivityType('InvoicesList', RouteActivityType.SharedResources)
    },
    {
        code: 'SharedRessourcesStatusParameters',
        route: getRouteByActivityType('StatusParameters', RouteActivityType.SharedResources)
    },
    {
        code: 'SharedRessourcesBorrowReserve',
        route: getRouteByActivityType('BookingsAvailabilities', RouteActivityType.SharedResources)
    },
    {
        code: 'SharedRessourcesReservationsList',
        route: getRouteByActivityType('BookingsList', RouteActivityType.SharedResources)
    },
    {
        code: 'SharedRessourcesPrintLabelParameters',
        route: [
            {
                content: 'activity/shared-resources/settings/sheets-models/list',
                focus: 'empty'
            }, {
                primaryRoute: 'content',
                queryParams: {closeButton: '1'}
            }
        ]
    },
];
